import { createSelector } from 'reselect';

const selectPushNotificationsState = createSelector(
  state => state,
  ({ pushNotifications }) => pushNotifications,
);

export const selectPushNotificationItems = createSelector(
  selectPushNotificationsState,
  ({ items }) => items,
);

export const selectPushNotificationNextCursor = createSelector(
  selectPushNotificationsState,
  ({ nextCursor }) => nextCursor,
);

export const selectPushNotificationHasMore = createSelector(
  selectPushNotificationsState,
  ({ hasMore }) => hasMore,
);

export const selectPushNotificationUnreadCount = createSelector(
  selectPushNotificationsState,
  ({ unreadCount }) => unreadCount,
);

export const selectPushNotificationFilters = createSelector(
  selectPushNotificationsState,
  ({ filters }) => filters,
);

export const selectPushNotificationGroups = createSelector(selectPushNotificationItems, items => {
  const { importantItems, regularItems } = items.reduce(
    (acc, item) => {
      if (item.isImportant) {
        acc.importantItems.push(item);

        return acc;
      }

      acc.regularItems.push(item);

      return acc;
    },
    { importantItems: [], regularItems: [] },
  );

  const sortedItems = [...importantItems, ...regularItems];

  const groupsByKey = sortedItems.reduce((acc, item) => {
    const key = item.groupId;

    if (acc[key]) {
      acc[key].items.push(item);

      return acc;
    }

    acc[key] = {
      groupId: item.groupId,
      groupKey: item.groupKey,
      items: [item],
    };

    return acc;
  }, {});

  return Object.values(groupsByKey);
});
